import api from '../api';

const dockerApiService = {
  getDockerInfoByAgent: async (agentId) => {
    if (!agentId) throw new Error('Agent ID is required');
    const response = await api.get(`/alerts/docker/${agentId}`);
    return response.data || response;
  },
};

export default dockerApiService;
